import styled from 'styled-components';

export const Container = styled.div`
  .toolbox-section--header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 30px;

    .toolbox-section--logo {
      height: 59px;

      @media (max-width: 576px) {
        height: 31px;
      }
    }
  }
  .toolbox-section--view-all-resources-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 200px;
    .toolbox-section--view-all-resources {
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 150%;

      a {
        color: #ffffff;
      }
    }
    @media (max-width: 576px) {
      margin-bottom: 25px;
      .toolbox-section--view-all-resources {
        font-size: 16px;
      }
    }
  }
  .toolbox-section--copy {
    width: 65%;
    margin-bottom: 40px;
    p {
      margin: 0px;
    }
    @media (max-width: 576px) {
      width: 100%;
    }
  }
`;
